import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'duplicatesFilter',
    standalone: false
})
export class DuplicatesFilterPipe implements PipeTransform {

  transform(items: any, filter: string): any {
    const seen = {};
    return items.filter((item) => {
      const k = item[filter];
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  }
}
